import { MessageSquareText, FileText, Network, CalendarClock, ChartNoAxesColumn, ShieldCheck } from 'lucide-react'

// Icon per AI Operations Suite step, keyed by step id in aiOpsSuite.js.
export const stepIcons = {
  'prompt-shaping': MessageSquareText,
  docflow: FileText,
  'conductor-canvas': Network,
  'workflow-catalog': CalendarClock,
  attribution: ChartNoAxesColumn,
  governed: ShieldCheck,
}
